import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const STANDING_PORTRAIT = 'https://customer-assets.emergentagent.com/job_d4801e57-518e-48e3-b04b-23ec30a7a74e/artifacts/5dmjmfy9_Romero%20Photo%20transparant%20background..png';
const WRITING_PORTRAIT  = 'https://customer-assets.emergentagent.com/job_d4801e57-518e-48e3-b04b-23ec30a7a74e/artifacts/5g5lplp3_Screenshot%202026-06-04%20at%2011.56.15%E2%80%AFAM.png';

export const VideoCollage = () => {
  return (
    <section className="welcome-banner" data-testid="home-welcome-banner">
      <div className="wb-container">
        {/* Left — Editorial copy */}
        <div className="wb-content-col">
          <p className="wb-eyebrow">
            <span className="wb-eyebrow-line" />
            WELCOME
          </p>

          <h1 className="wb-headline">
            Hello,<br />
            I&apos;m <span className="wb-headline-name">Romero</span>.
          </h1>

          <p className="wb-lede">
            Minister, author, and master clothier &mdash; and I&apos;m so glad you&apos;re here.
            Whatever brought you to this page, I believe your steps were ordered. Make yourself at home.
          </p>

          <div className="wb-pillars" data-testid="welcome-pillars">
            <div className="wb-pillar">
              <span className="wb-pillar-num">01</span>
              <span className="wb-pillar-label">Anointed</span>
              <span className="wb-pillar-sub">to Inspire</span>
            </div>
            <div className="wb-pillar">
              <span className="wb-pillar-num">02</span>
              <span className="wb-pillar-label">Gifted</span>
              <span className="wb-pillar-sub">to Create</span>
            </div>
            <div className="wb-pillar">
              <span className="wb-pillar-num">03</span>
              <span className="wb-pillar-label">Driven</span>
              <span className="wb-pillar-sub">to Build</span>
            </div>
          </div>

          <div className="wb-cta-row">
            <Link to="/ministry" className="wb-cta wb-cta-primary" data-testid="vc-cta-ministry">
              Explore Ministry
              <ArrowRight size={16} className="ml-2" />
            </Link>
            <Link to="/clothier" className="wb-cta wb-cta-secondary" data-testid="vc-cta-clothier">
              Custom Clothier
              <ArrowRight size={16} className="ml-2" />
            </Link>
          </div>

          {/* Signature row */}
          <div className="wb-signature" data-testid="welcome-signature">
            <img
              src={WRITING_PORTRAIT}
              alt="Romero Sumpter signing a book"
              className="wb-signature-img"
            />
            <div className="wb-signature-text">
              <span className="wb-signature-script">Glad you&apos;re here</span>
              <span className="wb-signature-name">— Romero Sumpter</span>
            </div>
          </div>
        </div>

        {/* Right — Standing portrait */}
        <div className="wb-portrait-col">
          <span className="wb-portrait-accent" aria-hidden="true" />
          <img
            src={STANDING_PORTRAIT}
            alt="Romero Sumpter"
            className="wb-portrait-img"
            data-testid="welcome-standing-portrait"
          />
        </div>
      </div>
    </section>
  );
};

export default VideoCollage;
